$(function(){
  masterPromo(false);
  removeKitProduct();
  cartRedirection();
  refParameter();
  beAMember();
  beAMember1();
  beAMember2();
  beAMember3();
  beAMember4();
  beAMember5();
  beAMember6();
  openStoreSelectorOnload();
  updateConsultantOnLoad();
  selectedConsultant();
  storeifyOnClickPin();
  onloadSidebarAccount();
  initBirthdayPicker();
  storePoint();
  cartJSLoader();
});

cartJSLoader = () =>{
  var $loader = $('.jsc-loader-overlay');
  $(document).on('cart.requestStarted', function(event, cart) {
    $loader.show();
  }).on('cart.requestComplete', function(event, cart) {
    $loader.hide();
  });
}

switchPromo = () =>{
  var $switchElm = $('.jsc-switch-variant');

  $switchElm.each(function(){
    var $this = $(this);
    var $vid = parseInt($this.val());
    var $key = $this.attr('data-key');
    var $qty = parseInt($this.attr('data-qty'));

    cartJSUpdateQuery($key, 0,{}, true);
    cartJSAddQuery($vid,$qty,{}, true);
  });
}

cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  CartJS.addItem(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          getThis.element.dispatchEvent(new CustomEvent('product:added', {
            bubbles: isOpenDrawer,
            detail: {
              variant: vid,
              quantity: qty
            }
          }));
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  CartJS.updateItemById(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          getThis.element.dispatchEvent(new CustomEvent('product:added', {
            bubbles: isOpenDrawer,
            detail: {
              variant: vid,
              quantity: qty
            }
          }));
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

//Start GWP promo
gwpFunction = (isOpenDrawer) =>{
  $.when($.getJSON('/cart.js', function(cart) {

  })).then(function(cart){
    var $gwpcart_product = {};
    var $addEle = $('.jsc-add-gwp');
    var $updateEle = $('.jsc-update-gwp');
    var $deleteEle = $('.jsc-remove-gwp');

    $gwpcart_product['_Promo'] = 'Free Gift';

    $addEle.each(function() {
      var $vid = parseInt($(this).val());
      var $qty = parseInt($(this).attr('data-qty'));

      $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

      cartJSAddQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
    });

    $updateEle.each(function() {
      var $vid = $(this).val();
      var $qty = parseInt($(this).attr('data-qty'));

      $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

      cartJSUpdateQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
    });

    $deleteEle.each(function() {
      var $vid = $(this).val();
      var $qty = 0;

      cartJSUpdateQuery($vid, $qty, {}, isOpenDrawer);
    });

  });
}

tierFunction = (isOpenDrawer) =>{
  var $updateEle = $('.jsc-tier-product');
  var $removeEle = $('.jsc-tier-product-remove');

  $updateEle.each(function(){
    var $obj = {};
    var $this = $(this);
    var $key = $this.attr('data-key');
    var $discountVal = $this.val();
    var $discountType = $this.attr('data-discount-type');
    var $tierNo = $this.attr('data-promo-no');
    var $qty = parseInt($this.attr('data-qty'));

    $obj['_Quantity-Promo'] = $discountType;
    $obj['_Off-Value'] = $discountVal;
    $obj['_Promo-no'] = $tierNo;
    $obj['_Tier'] = true;

    cartJSUpdateQuery($key, $qty, $obj, isOpenDrawer);
  });

  $removeEle.each(function(){
    var $this = $(this);
    var $key = $this.val();
    var $promoNo = $this.attr('data-promo-no');
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        var $vID = parseInt($items[i].variant_id);

        if ($thisKey == $key && $thisProps['_Promo-no'] == $promoNo) {
          delete $thisProps['_Quantity-Promo'];
          delete $thisProps['_Off-Value'];
          delete $thisProps['_Promo-no'];
          delete $thisProps['_Tier'];

          var $isEmptyProperty = $.isEmptyObject($thisProps);
          if ($isEmptyProperty) {
            // if properties is empty then, remove the product and add back
            replaceProduct($thisKey, $vID, $thisQty, isOpenDrawer);
          } else {
            // if properties not empty then, just update the properties
            cartJSUpdateQuery($thisKey, $thisQty, $thisProps, isOpenDrawer);
          }
        }
      }
    });
  });
}

replaceProduct = ($key, $vid, $qty, isOpenDrawer) =>{
  CartJS.removeItemById($key,
  {
    "success": function(data, textStatus, jqXHR) {
      getThis.element.dispatchEvent(new CustomEvent('product:added', {
        bubbles: isOpenDrawer,
        detail: {
          variant: $vid,
          quantity: $qty
        }
      }));
      cartJSAddQuery($vid, $qty, {}, isOpenDrawer);
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

variantOption = (evt, index, setValue) =>{
  var $this = $(evt);
  var $thisImgUrl = $this.find(':selected').attr('data-img');
  var $thisVid = $this.val();
  var $thisPrice = parseInt($this.find(':selected').attr('data-price'));
  var $thisTitle = $this.find(':selected').text();
  var $thisComparePrice = parseInt($this.find(':selected').attr('data-compare-price'));
  var $isDiscounted = $this.find(':selected').attr('data-settings-discount') == 'true';
  var $currencyFormat = $('html').attr('data-currency');
  var $variantTitleEle = $this.parent().find('span.jsc-variant-title');

  var $hiddenEle = $this.parents('.jsc-container').find('.jsc-hidden');
  var $discountType = $hiddenEle.val();
  var $minusPrice = $discountType == 'percentage-off' ? parseFloat($hiddenEle.attr('data-'+$discountType+'-'+index)) : parseInt($hiddenEle.attr('data-'+$discountType+'-'+index));

  // update image
  $this.parent().find('img').attr('src', $thisImgUrl);

  // update price
  if ($isDiscounted) { // if discount value is not empty in theme settings, then calculate the price
    var $discountedValue = 0;
    if ($discountType == 'percentage-off') {
      $discountedValue = $thisPrice * $minusPrice;
    } else {
      $discountedValue = $thisPrice - $minusPrice;
    }
    $this.siblings('.jsc-price').find('strike').text(Shopify.formatMoney(($thisPrice), $currencyFormat));
    $this.siblings('.jsc-price').find('span').first().text(Shopify.formatMoney(($discountedValue), $currencyFormat));
  } else { // if discount value is empty in theme settings, then show normal price
    if ($thisComparePrice) {
      $this.siblings('.jsc-price').find('strike').text(Shopify.formatMoney(($thisComparePrice), $currencyFormat));
      $this.siblings('.jsc-price').find('strike').show();
    } else {
      $this.siblings('.jsc-price').find('strike').hide();
    }
    $this.siblings('.jsc-price').find('span').first().text(Shopify.formatMoney(($thisPrice), $currencyFormat));
  }

  // update variant ID
  $this.parent().attr('data-vid', $thisVid);

  // This function is to hide atc btn and show limit message if pwp reached the set limit
  if (setValue) {
    pwpSetValidationPdp(setValue, $this);
  }

  if ($variantTitleEle.length > 0) {
    $variantTitleEle.html($thisTitle);
  }
}

bundleAddToCart = (evt,discount1,discount2, discountType, i) =>{
  var $this = $(evt);
  var properties1 = {};
  var properties2 = {};
  var vid1 = parseInt($this.parent().find('.jsc-bundle-col-1').attr('data-vid'));
  var vid2 = parseInt($this.parent().find('.jsc-bundle-col-2').attr('data-vid'));
  var $bindId = vid1+'-'+vid2;


  properties1['_Quantity-Promo'] = discountType;
  properties1['_Off-Value'] = discount1;
  properties1['_Bundle'] = true;
  properties1['_BindID'] = $bindId;
  properties1['_Promo-no'] = i;

  properties2['_Quantity-Promo'] = discountType;
  properties2['_Off-Value'] = discount2;
  properties2['_Bundle'] = true;
  properties2['_BindID'] = $bindId;
  properties2['_Promo-no'] = i;

  cartJSAddQuery(vid1, 1, properties1, true);
  cartJSAddQuery(vid2, 1, properties2, true);
}

removeBundle = (evt, bindid) =>{
  setTimeout(function(){
    bundleCartAjax(bindid);
  },900);
}

removeBundleOnThemeSettings = () =>{
  var $removeEle = $('.jsc-remove-bundle');

  $removeEle.each(function(){
    var $this = $(this);
    var $bindId = $this.val();
    var $container = $('.'+$this.attr('data-container'));

    if ($container.length > 0) {
      $container.hide();
    }

    setTimeout(function(){
      bundleCartAjax($bindId);
    },900);
  })

}

bundleCartAjax = (bindid) =>{
  $.when($.getJSON('/cart.js')).then(function(cart){
    var $items = cart.items;
    for (var i = 0; i < $items.length; i++) {
      var $thisKey = $items[i].key;
      var $thisQty = $items[i].quantity;
      var $thisProps = $items[i].properties;
      var $vID = parseInt($items[i].variant_id);

      if ($thisProps['_BindID'] == bindid) {
        delete $thisProps['_Quantity-Promo'];
        delete $thisProps['_Off-Value'];
        delete $thisProps['_Bundle'];
        delete $thisProps['_BindID'];
        delete $thisProps['_Promo-no'];

        var $isEmptyProperty = $.isEmptyObject($thisProps);
        if ($isEmptyProperty) {
          // if properties is empty then, remove the product and add back
          replaceProduct($thisKey, $vID, $thisQty, true);
        } else {
          // if properties not empty then, just update the properties
          cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
        }
      }
    }
  });
}

pwpAddToCart = (evt,discount2, discountType, index) =>{
  var $this = $(evt);
  var properties1 = {};
  var properties2 = {};
  var vid1 = parseInt($this.parent().find('.jsc-pwp-col-1').attr('data-vid'));
  var vid2 = parseInt($this.parent().find('.jsc-pwp-col-2').attr('data-vid'));
  var $bindId = vid1+'-'+vid2;


  properties1['_PWP'] = 'Master';
  properties1['_BindID'] = $bindId;
  properties1['_Promo-No'] = index;


  properties2['_Quantity-Promo'] = discountType;
  properties2['_Off-Value'] = discount2;
  properties2['_PWP'] = 'Child';
  properties2['_BindID'] = $bindId;
  properties2['_Promo-No'] = index;

  cartJSAddQuery(vid1, 1, properties1, true);
  cartJSAddQuery(vid2, 1, properties2, true);
}

removePwp = (evt, bindid, pwp) =>{
  setTimeout(function(){
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        var $vID = parseInt($items[i].variant_id);

        if ($thisProps['_BindID'] == bindid) {

          if (pwp == 'Master') {
            // if customer remove master product we remove the child product
            cartJSUpdateQuery($thisKey, 0, {}, true);
          } else if (pwp == 'Child') {
            // if customer remove child product we keep the master product, but remove the pwp properties
            delete $thisProps['_Quantity-Promo'];
            delete $thisProps['_Off-Value'];
            delete $thisProps['_BindID'];
            delete $thisProps['_PWP'];
            delete $thisProps['_Promo-No'];

            var $isEmptyProperty = $.isEmptyObject($thisProps);
            if ($isEmptyProperty) {
              // if properties is empty then, remove the product and add back
              replaceProduct($thisKey, $vID, $thisQty, true);
            } else {
              // if properties not empty then, just update the properties
              cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
            }
          }
        }
      }
    });
  },900);
  $(document).on('cart.requestComplete', function(event, cart) {
    pwpSetValidationCart();
  });
}

updatePwp = (evt,bindid) =>{
  setTimeout(function(){
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        $thisQty -= 1;
        if ($thisProps['_BindID'] == bindid && $thisProps['_PWP'] == 'Child') {
          cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
          console.log('slow333', $thisQty);
        }
      }
    });
  },900);
}

pwpSetValidationPdp = (setValue, $this) =>{
  var $v1 = $this.parents('.jsc-container').find('.jsc-pwp-col-1').attr('data-vid');
  var $v2 = $this.parents('.jsc-container').find('.jsc-pwp-col-2').attr('data-vid');
  var $bId = $v1+'-'+$v2;
  var $isInCart = false;
  $.when($.getJSON('/cart.js')).then(function(cart){
    var $items = cart.items;
    for (var i = 0; i < $items.length; i++) {
      var $thisQty = $items[i].quantity;
      var $thisProps = $items[i].properties;

      if ($thisProps['_BindID'] == $bId && $thisProps['_PWP'] == 'Child') {
        if ($thisQty >= setValue) { // if pwp variant have reached set limit
          $this.parents('.jsc-container').find('.jsc-set-limit-msg').show();
          $this.parents('.jsc-container').find('.jsc-atc-btn').hide();
        } else { // if pwp variant not yet reached set limit
          $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
          $this.parents('.jsc-container').find('.jsc-atc-btn').show();
        }
        $isInCart = true;
      }
    }

    // if variant is not in cart
    if (!$isInCart) {
      $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
      $this.parents('.jsc-container').find('.jsc-atc-btn').show();
    }
  });
}

pwpSetValidationCart = () =>{
  var $pwpContainer = $('.jsc-pwp-container');

  $pwpContainer.each(function(){
    var $this = $(this);
    var $v1 = $this.find('.jsc-pwp-col-1').attr('data-vid');
    var $v2 = $this.find('.jsc-pwp-col-2').attr('data-vid');
    var $bId = $v1+'-'+$v2;
    var $isInCart = false;
    var $setValue = parseInt($this.attr('data-set'));

    if ($setValue) {
      $.when($.getJSON('/cart.js')).then(function(cart){
        var $items = cart.items;
        for (var i = 0; i < $items.length; i++) {
          var $thisQty = $items[i].quantity;
          var $thisProps = $items[i].properties;

          if ($thisProps['_BindID'] == $bId && $thisProps['_PWP'] == 'Child') {
            if ($thisQty >= $setValue) { // if pwp variant have reached set limit
              $this.find('.jsc-set-limit-msg').show();
              $this.find('.jsc-atc-btn').hide();
            } else { // if pwp variant not yet reached set limit
              $this.find('.jsc-set-limit-msg').hide();
              $this.find('.jsc-atc-btn').show();
            }
            $isInCart = true;
          }
        }
        // if variant is not in cart
        if (!$isInCart) {
          $this.find('.jsc-set-limit-msg').hide();
          $this.find('.jsc-atc-btn').show();
        }
      });
    }
  });
}

removePwpOnThemeSettings = () =>{
  var $parent = $('.jsc-remove-pwp-parent');
  var $child = $('.jsc-remove-pwp-child');

  // Remove line item properties for parent products
  $parent.each(function(){
    var $this = $(this);
    var $vid = $this.val();
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        var $vID = parseInt($items[i].variant_id);

        if ($thisProps['_PWP'] == 'Master' && $vid == $thisKey) {
          delete $thisProps['_Quantity-Promo'];
          delete $thisProps['_Off-Value'];
          delete $thisProps['_BindID'];
          delete $thisProps['_PWP'];
          delete $thisProps['_Promo-No'];

          var $isEmptyProperty = $.isEmptyObject($thisProps);
          if ($isEmptyProperty) {
            // if properties is empty then, remove the product and add back
            replaceProduct($thisKey, $vID, $thisQty, true);
          } else {
            // if properties not empty then, just update the properties
            cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
          }
        }
      }
    });
  });

  // Remove child product
  $child.each(function(){
    var $this = $(this);
    var $vid = $this.val();
    var $promo = $this.attr('data-container');
    var $pwpContainer = $('.jsc-pwp-container-'+$promo);

    cartJSUpdateQuery($vid, 0, {}, true);
    if ($pwpContainer.length > 0) {
      $pwpContainer.hide();
    }
  });
}

removeKitProduct = () =>{
  var $kit = $('.jsc-remove-kit');
  $kit.each(function(){
    var $key = $(this).val();

    cartJSUpdateQuery($key, 0, {}, true);
  });
}

orderBuilderAddToCart = (evt, discount, discountType, index) =>{
  var $this = $(evt);
  var $properties = {};
  var $vid = parseInt($this.parent().find('.jsc-order-builder-col').attr('data-vid'));
  var $qtyEle = $this.parent().find('.jsc-qty-selector');
  var $qty = parseInt($qtyEle.val());


  $properties['_Quantity-Promo'] = discountType;
  $properties['_Off-Value'] = discount;
  $properties['_Order-Builder'] = true;
  $properties['_Promo-No'] = index;

  cartJSAddQuery($vid, $qty, $properties, true);

  // update the quantity dropdown and button
  var $totolQty = parseInt($qtyEle.children().last().val());
  $qtyEle.children().remove();

  $totolQty -= $qty;

  if ($totolQty == 0) {
    var $html = `<option value="0">0</option>`;
    $qtyEle.append($html);
    $this.hide();
    $this.parent().find('.jsc-set-limit-msg').show();
  }else if ($totolQty > 0) {
    for (var i = 1; i <= $totolQty; i++) {
      var $html = `<option value="${i}">${i}</option>`;
      $qtyEle.append($html);
    }
  }
}

orderBuilderValidationCart = () =>{
  var $ele = $('.jsc-orderbuilder-cart');
  var $eleQty = $('.jsc-orderbuilder-qty');
  var $eleRemove = $('.jsc-orderbuilder-remove');

  // Disable/enable order builder grid
  $ele.each(function(){
    var $this = $(this);
    var $isEnable = $this.val() == 'true';
    var $container = $('.'+$this.attr('data-container'));

    // This condition is to enable or disable the order builder grid on the fly
    if ($isEnable) {
      $container.find('.jsc-block-product-grid').hide();
      $container.find('.jsc-qty-selector').show();
    } else {
      $container.find('.jsc-block-product-grid').show();
      $container.find('.jsc-qty-selector').hide();
    }
  });

  // Update order builder quntity selector and atc btn
  $eleQty.each(function(){
    var $this = $(this);
    var $availableQty = Math.abs(parseInt($this.val()));
    var $maxQty = parseInt($this.attr('data-max-qty'));
    var $container = $('.'+$this.attr('data-container'));
    var $qtyEle = $container.find('.jsc-qty-selector');

    if ($availableQty > 0) {
      $qtyEle.children().remove();
      for (var i = 1; i <= $availableQty; i++) {
        var $html = `<option value="${i}">${i}</option>`;
        $qtyEle.append($html);
      }

      $container.find('.jsc-set-limit-msg').text(`Only ${$maxQty} item(s) can be added`);
      $container.find('.jsc-set-limit-msg').hide();
      $container.find('.Button--primary').show();
    } else {
      $qtyEle.children().remove();
      var $html = `<option value="0">0</option>`;
      $qtyEle.append($html);

      $container.find('.jsc-set-limit-msg').text(`Only ${$maxQty} item(s) can be added`);
      $container.find('.jsc-set-limit-msg').show();
      $container.find('.Button--primary').hide();
    }
  });

  // Remove order builder
  $eleRemove.each(function(){
    var $this = $(this);
    var $key = $this.val();
    var $container = $('.'+$this.attr('data-container'));

    cartJSUpdateQuery($key, 0, {}, true);

    $container.find('.Button--primary').show();
    $container.find('.jsc-set-limit-msg').hide();
  });
}

redirectCheckout = (e) =>{
  setTimeout(function(){
    $('.Cart__Checkout').click();
  },1200);
}

cartRedirection = () =>{
  var $pathName = location.pathname;
  if ($pathName == '/cart') {
    location.href = '/';
  }
}

refParameter = () =>{
  setRefStorage();
  getRefStorage();
}

setRefStorage = () =>{
  var $ref = urlParam('ref',window.location.href);

  if ($ref !== null) {
    if ($ref.includes('ref%')) {
      var $lowCase = $ref.toLowerCase();
      $ref = $lowCase.split('3d')[1];
    }
  }

  if ($ref != null && $ref != 0) {
    localStorage.setItem("referral-code", $ref);
  }
}

getRefStorage = () =>{
  // credit to: https://www.codegrepper.com/code-examples/javascript/update+param+in+url+jquery
  var $ref = localStorage.getItem("referral-code");

  if ($ref !== null) {
    var url = new URL(window.location.href);
    var search_params = url.searchParams;

    // add "ref" parameter
    search_params.set('ref', $ref);

    url.search = search_params.toString();

    // update url parameter
    window.history.replaceState(null, null, url.search);

    refAttributes($ref);
  }
}

refAttributes = (ref) =>{
  $.when($.getJSON('/cart.js')).then(function(cart){
    var $currentAttr = cart.attributes['Referral code'];
    if (ref != $currentAttr) {
      CartJS.setAttribute('Referral code', ref);
    }
  });
}

urlParam = (name,url) =>{
  // credit to: https://www.sitepoint.com/url-parameters-jquery/
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url);
    if (results==null){
       return null;
    }
    else{
       return results[1] || 0;
    }
}

beAMember = () =>{
  var $a = $('#jsc-be_a_member');
  var $href = $a.attr('data-href');

  var $getLocalStorage = localStorage.getItem("referral-code");
  var $parameter = '';
  if ($getLocalStorage !== null) {
    $parameter = '?ref='+$getLocalStorage;
  }

  if ($parameter == '') {
    $a.attr('href', $href);
  } else {
    $a.attr('href', $href+$parameter);
  }
}

beAMember1 = () =>{
  var $a = $('#jsc-be_a_member1');
  var $href = $a.attr('data-href');

  var $getLocalStorage = localStorage.getItem("referral-code");
  var $parameter = '';
  if ($getLocalStorage !== null) {
    $parameter = '?ref='+$getLocalStorage;
  }

  if ($parameter == '') {
    $a.attr('href', $href);
  } else {
    $a.attr('href', $href+$parameter);
  }
}

beAMember2 = () =>{
  var $a = $('#jsc-be_a_member2');
  var $href = $a.attr('data-href');

  var $getLocalStorage = localStorage.getItem("referral-code");
  var $parameter = '';
  if ($getLocalStorage !== null) {
    $parameter = '?ref='+$getLocalStorage;
  }

  if ($parameter == '') {
    $a.attr('href', $href);
  } else {
    $a.attr('href', $href+$parameter);
  }
}

beAMember3 = () =>{
  var $a = $('#jsc-be_a_member3');
  var $href = $a.attr('data-href');

  var $getLocalStorage = localStorage.getItem("referral-code");
  var $parameter = '';
  if ($getLocalStorage !== null) {
    $parameter = '?ref='+$getLocalStorage;
  }

  if ($parameter == '') {
    $a.attr('href', $href);
  } else {
    $a.attr('href', $href+$parameter);
  }
}

beAMember4 = () =>{
  var $a = $('#jsc-be_a_member4');
  var $href = $a.attr('data-href');

  var $getLocalStorage = localStorage.getItem("referral-code");
  var $parameter = '';
  if ($getLocalStorage !== null) {
    $parameter = '?ref='+$getLocalStorage;
  }

  if ($parameter == '') {
    $a.attr('href', $href);
  } else {
    $a.attr('href', $href+$parameter);
  }
}

beAMember5 = () =>{
  var $a = $('#jsc-be_a_member5');
  var $href = $a.attr('data-href');

  var $getLocalStorage = localStorage.getItem("referral-code");
  var $parameter = '';
  if ($getLocalStorage !== null) {
    $parameter = '?ref='+$getLocalStorage;
  }

  if ($parameter == '') {
    $a.attr('href', $href);
  } else {
    $a.attr('href', $href+$parameter);
  }
}

beAMember6 = () =>{
  var $a = $('#jsc-be_a_member6');
  var $href = $a.attr('data-href');

  var $getLocalStorage = localStorage.getItem("referral-code");
  var $parameter = '';
  if ($getLocalStorage !== null) {
    $parameter = '?ref='+$getLocalStorage;
  }

  if ($parameter == '') {
    $a.attr('href', $href);
  } else {
    $a.attr('href', $href+$parameter);
  }
}

kitAddToCart = (e, label) =>{
  var $this = $(e);
  var $vid = parseInt($this.parent().attr('data-vid'));
  var $obj = {};

  $obj['_Kit'] = label;
  cartJSAddQuery($vid, 1, $obj, true);
  $(document).on('cart.requestComplete', function(event, cart) {
    masterPromo(true);
  });
}

storeLocator = (e,url) =>{
  var $this = $(e);
  var $ref = urlParam('ref',url);

  storeLocatorDataUpdate($ref);

  getConsultantJson($ref, true, $this);
}

getConsultantJson = (ref,isSelected, $this) =>{
  var $ref = parseInt(ref);
  var $url = $('#jsc-consultant-json').val();
  if ($url) {
    $.getJSON($url, function(data) {
        var $name = '';
        var $dataArray = data.storepointAll79965071Ea6F;

        for (var i = 0; i < $dataArray.length; i++) {
          var $dataName = $dataArray[i].name;

          if ($dataName.includes($ref)) {
            var $removeText = ` | ${$ref}`;
            $name = $dataName.replace($removeText, '');
          }
        }

        if ($name != '') {
          $('.jsc-consultant-name').text($name);
          $('.jsc-consultant-hover-content').hide();
          if (isSelected) {
            $this.text('Selected Consultant').addClass('jsc-selected-consultant');
          }
        }else {
          $('.jsc-consultant-header').hide();
        }
    });
  }
}

selectedConsultant = () =>{
  $(document).on("click", ".new-for-mobile .scasl-location-list ul.list > li", function() {
    setTimeout(function(){
      var $urlRef = urlParam('ref',window.location.href);
      var $mapRef = urlParam('ref',$('#scasl-window-container').find('#scasl-web').attr('data-url'));
      if ($urlRef == $mapRef) {
        var $conBtn = $('#scasl-window-container').find('#scasl-web').find('.Button');
        $conBtn.text('Selected Consultant').addClass('jsc-selected-consultant');
      }
    },900);
  });
  $(document).on("click", "#bh-sl-map div[role='button']", function() {
    var $urlRef = urlParam('ref',window.location.href);
    var $mapRef = urlParam('ref',$('#scasl-window-container').find('#scasl-web').attr('data-url'));
    if ($urlRef == $mapRef) {
      var $conBtn = $('#scasl-window-container').find('#scasl-web').find('.Button');
      $conBtn.text('Selected Consultant').addClass('jsc-selected-consultant');
    }
  });

}

updateConsultantOnLoad = () =>{
  var $ref = localStorage.getItem("referral-code");
  if ($ref) {
    getConsultantJson($ref, false, null);
  }
}

storeLocatorDataUpdate = ($ref) =>{
  if ($ref !== null) {
    var url = new URL(window.location.href);
    var search_params = url.searchParams;

    // add "ref" parameter
    search_params.set('ref', $ref);

    url.search = search_params.toString();

    // update url parameter
    window.history.replaceState(null, null, url.search);
    setRefStorage();
    refAttributes($ref);
  }
}

termsOption = (e) =>{
  var $this = $(e);
  var $overlay = $('.jsc-drawer-btn-disabled');
  var $obCheckoutBtn = $('#jsc-ob-checkout-btn');
  var $tncError = $('.jsc-tnc-error');

  if ($this.is(':checked')) {
    $overlay.hide();
    CartJS.setAttribute('Terms and Conditions', 'Yes');
    if ($tncError.length > 0) {
      $tncError.hide();
    }
    if ($obCheckoutBtn.length > 0) {
      $obCheckoutBtn.prop('disabled',false);
    }
    $('.jsc-tnc-input').attr("checked", "checked");
  } else {
    $overlay.show();
    CartJS.setAttribute('Terms and Conditions', 'No');
    if ($tncError.length > 0) {
      $tncError.show();
    }
    if ($obCheckoutBtn.length > 0) {
      $obCheckoutBtn.prop('disabled',true);
    }
    $('.jsc-tnc-input').removeAttr('checked');
  }
}

isValidcounsultant = ($urlRef) =>{
  var $ref = parseInt($urlRef);
  var $url = $('#jsc-consultant-json').val();
  var $isValid = false;

  if ($ref) {
    if ($url) {
      $.getJSON($url, function(data) {
        var $name = data[$ref];

        if ($name) {
          $isValid = true;
        }else {
          $isValid = false;
        }
      }).done(function() {
        return $isValid;
      });
    }
  }else {
    return 'empty';
  }

}

storeifyOnClickPin = () =>{
  $(document).on("click touchend", "#map div[role='button']", function(e) {
    setTimeout(function(){
      var $dialogBox = $(e.currentTarget).parents('div[role="group"]').find('div[role="dialog"]');
      var $mapUrl = $dialogBox.find('.storeify-storelocator-web').attr('href');

      var $urlRef = urlParam('ref',window.location.href);
      var $mapRef = urlParam('ref',$mapUrl);
      var $isValidConsultant = isValidcounsultant($urlRef);
      var $styleHide = `style="display: none;"`;

      if ($urlRef == $mapRef) {
        if ($isValidConsultant == 'empty' || $isValidConsultant){
          var $html = `<a class="Button Button--secondary cursor fontWeight-9 jsc-selected-consultant uppercase">Selected Consultant</a>`;
        } else if (!$isValidConsultant){
          var $html = `<a class="Button Button--secondary cursor fontWeight-9 jsc-selected-consultant uppercase" ${$styleHide}>Selected Consultant</a>`;
        }

        $($html).insertAfter($dialogBox.find('.marker-link'));
      } else {
        if ($isValidConsultant == 'empty') {
          var $html = `<a onclick="storeifyOnClickSelectConsultant(this,'${$mapUrl}')" class="Button Button--secondary cursor fontWeight-9 uppercase">Select Consultant</a>`;
        }else if ($isValidConsultant || !$isValidConsultant) {
          var $html = `<a onclick="storeifyOnClickSelectConsultant(this,'${$mapUrl}')" class="Button Button--secondary cursor fontWeight-9 uppercase" ${$styleHide}>Select Consultant</a>`;
        }
        $($html).insertAfter($dialogBox.find('.marker-link'));
      }
    },30);
  });
  $(document).on("click touchend", "#main-slider-storelocator .inner-item", function(e) {
    setTimeout(function(){
      var $this = $(e.currentTarget);
      var $dialogBox = $('#map').find('div[role="dialog"]');
      var $mapUrl = $this.find('.storeify-storelocator-web').attr('href');

      var $urlRef = urlParam('ref',window.location.href);
      var $mapRef = urlParam('ref',$mapUrl);
      var $isValidConsultant = isValidcounsultant($urlRef);
      var $styleHide = `style="display: none;"`;

      if ($urlRef == $mapRef) {
        if ($isValidConsultant == 'empty' || $isValidConsultant){
          var $html = `<a class="Button Button--secondary cursor fontWeight-9 jsc-selected-consultant uppercase">Selected Consultant</a>`;
        } else if (!$isValidConsultant){
          var $html = `<a class="Button Button--secondary cursor fontWeight-9 jsc-selected-consultant uppercase" ${$styleHide}>Selected Consultant</a>`;
        }
        $($html).insertAfter($dialogBox.find('.marker-link'));
      } else {
        if ($isValidConsultant == 'empty') {
          var $html = `<a onclick="storeifyOnClickSelectConsultant(this,'${$mapUrl}')" class="Button Button--secondary cursor fontWeight-9 uppercase">Select Consultant</a>`;
        }else if ($isValidConsultant || !$isValidConsultant) {
          var $html = `<a onclick="storeifyOnClickSelectConsultant(this,'${$mapUrl}')" class="Button Button--secondary cursor fontWeight-9 uppercase" ${$styleHide}>Select Consultant</a>`;
        }
        $($html).insertAfter($dialogBox.find('.marker-link'));
      }
    },30);
  });
}

storeifyOnClickSelectConsultant = (e,url) =>{
  var $this = $(e);
  var $ref = urlParam('ref',url);

  storeLocatorDataUpdate($ref);

  getConsultantJson($ref, false, null);

  $this.text('Selected Consultant').addClass('jsc-selected-consultant');
}

storePoint = () =>{
  console.log('THANK YOU!!!');
  $(document).on("click touchend", "#storepoint-results-container .storepoint-location", function(e) {
    setTimeout(function(){
      var $dialogBox = $('.mapboxgl-popup-content');
      var $mapUrl = $dialogBox.find('.storepoint-popup-website').attr('href');

      var $urlRef = urlParam('ref',window.location.href);
      var $mapRef = urlParam('ref',$mapUrl);

      if ($urlRef == $mapRef) {
        $dialogBox.find('.Button').text('Selected Consultant').addClass('jsc-selected-consultant');
      } else {
        $dialogBox.find('.Button').text('Select Consultant').removeClass('jsc-selected-consultant');
      }
    },30);
  });
  $(document).on("click touchend", "#storepoint-map .mapboxgl-marker", function(e) {
    setTimeout(function(){
      var $dialogBox = $('.mapboxgl-popup-content');
      var $mapUrl = $dialogBox.find('.storepoint-popup-website').attr('href');

      var $urlRef = urlParam('ref',window.location.href);
      var $mapRef = urlParam('ref',$mapUrl);

      if ($urlRef == $mapRef) {
        $dialogBox.find('.Button').text('Selected Consultant').addClass('jsc-selected-consultant');
      } else {
        $dialogBox.find('.Button').text('Select Consultant').removeClass('jsc-selected-consultant');
      }
    },30);
  });
}

storepointSelect = (e) =>{
  var $this = $(e);
  var $url = $this.parents('.storepoint-location-popup').find('.storepoint-popup-website').text();
  var $ref = urlParam('ref',$url);

  storeLocatorDataUpdate($ref);

  getConsultantJson($ref, false, null);

  $this.text('Selected Consultant').addClass('jsc-selected-consultant');
}


signUpGift = () =>{
  addSignUpGift();
  removeSignUpGift();
}

addSignUpGift = () =>{
  var $elem = $('#jsc-sign-up-gift');
  var $vid = $elem.val();
  var $obj = {};

  $obj['_Sign Up Gift'] = true;
  if ($elem.length > 0) {
    cartJSAddQuery($vid,1,$obj,true);
  }
}

removeSignUpGift = () =>{
  var $elem = $('#jsc-sign-up-gift-remove');
  var $key = $elem.val();

  if ($elem.length > 0) {
    cartJSUpdateQuery($key, 0, {}, true);
  }
}

cartGift = () =>{
  setTimeout(function(){
    addCartGift();
    updateCartGift();
    removeCartGift();
  },3900);
}

addCartGift = () =>{
  var $elem = $('#jsc-cart-gift');
  var $vid = $elem.val();
  var $promoNo = $elem.attr('data-promo');
  var $qtyToAdd = parseInt($elem.attr('data-qty'));
  var $obj = {};

  $obj['_Cart_Gift'] = true;
  $obj['_Cart_Gift_Promo_No'] = $promoNo;
  $obj['Cart_Gift_maxQty'] = $qtyToAdd;
  if ($elem.length > 0) {
    cartJSAddQuery($vid,$qtyToAdd,$obj,true);
  }
}

updateCartGift = () =>{
  var $elem = $('#jsc-cart-gift-update');
  var $key = $elem.val();
  var $qtyToAdd = parseInt($elem.attr('data-qty'));
  
  if ($elem.length > 0) {
    cartJSUpdateQuery($key,$qtyToAdd,{},true);
  }
}

removeCartGift = () =>{
  var $elem = $('.jsc-cart-gift-remove');
  
  if ($elem.length > 0) {
    $elem.each(function(){
      var _this = $(this);
      var _key = _this.val();

      cartJSUpdateQuery(_key, 0, {}, true);
    });
  }
}

//Start onload and onclick all promo
masterPromo = (isDrawer) =>{
  setTimeout(function(){
    gwpFunction(isDrawer);
    tierFunction(isDrawer);
    pwpSetValidationCart();
    orderBuilderValidationCart();
    removeBundleOnThemeSettings();
    removePwpOnThemeSettings();
    signUpGift();
    cartGift();
    disableAtcLimitQty();
    resetCartNote();
    switchPromo();
  },1800);
}


onloadSidebarAccount = () =>{
  var urlParams = new URLSearchParams(window.location.search);
  var $viewNum = urlParams.get('sidebar');

  if (!$viewNum >= 1) {
    $viewNum = '1';
  }

  $('.jsc-account-contain').hide();
  $('#jsc-account-contain-'+$viewNum).show();
}

sidebarAccount = (evt, num) =>{
  var url = new URL(window.location.href);
  var search_params = url.searchParams;

  // add "ref" parameter
  search_params.set('sidebar', num);

  url.search = search_params.toString();

  // update url parameter
  window.history.replaceState(null, null, url.search);

  $('.jsc-account-contain').hide();
  $('#jsc-account-contain-'+num).show();
}

birthdayFunction = (evt) =>{
  var $return = {};
  $return['firstname'] = $('#AddressFirstNameNew').val();
  $return['lastname'] = $('#AddressLastNameNew').val();
  $return['email'] = $('#AddressEmail').val();
  $return['birthday'] = $('#jsc-birthday-text').val();

  var settings = {
    "url": "https://webhooks.mechanic.dev/c5cb5f77-144e-409f-ba31-c11db91f566c",
    "method": "POST",
    "timeout": 0,
    "headers": {
      "Content-Type": "application/json",
    },
    "data" : JSON.stringify($return)
  };

  $.ajax(settings).done(function(r){
    console.log('success',$return);
    alert('Details updated!')
  }).fail(function(response) {
    console.log("error",$return);
    console.log(response);
    // Happens when something goes wrong
  });
}

storeRedirect = (evt) =>{
  console.log('eve', evt);
  var $this = $(evt);
  var $store = $this.attr('data-store');
  var $storeOption = $('#jsc-selector');
  var $getLocalStorage = localStorage.getItem("referral-code");
  var $parameter = '';
  var $storeString = '';

  if (window.location.pathname != '/') {
    $parameter = window.location.pathname;
  }
  if ($getLocalStorage !== null) {
    if ($getLocalStorage.includes('storeSelector')) {
      $storeString = '';
    } else {
      $storeString = '&storeSelector=true';
    }
    $parameter += '?ref='+$getLocalStorage+$storeString;
  } else {
    $parameter += '?storeSelector=true';
  }

  // if ($store == 'em') {
  //   // URLS need to be changed in the future
  //   setSStorageSelector();
  //   this.CartJS.clear();
  //   window.location.href = "https://shop-em.tupperwarebrands.com.my"+$parameter;
  // } else if ($store == 'pm') {
  //   // URLS need to be changed in the future
  //   setSStorageSelector();
  //   this.CartJS.clear();
  //   window.location.href = "https://tupperware-my.myshopify.com"+$parameter;
  // }

  $storeOption.hide();
}

storeSelector = (evt) =>{
  var $this = $(evt);
  var $storeOption = $('#jsc-selector');

  $storeOption.show();
}

closeSelector = (evt) =>{
  var $this = $(evt);
  $('#jsc-selector').hide();
  setSStorageSelector();
}
setSStorageSelector = () =>{
  sessionStorage.setItem("isClosedStore", true);
}
openStoreSelectorOnload = () =>{
  var $getSessionStorage = sessionStorage.getItem("isClosedStore");

  if (!$getSessionStorage) {
    setTimeout(function(){
      if (!window.location.href.includes('storeSelector=true')) {
        $('#jsc-selector').show();
      }
    },3000);
  }
}

limitQty = (e, lmt_no) =>{
  var $this = $(e);
  var $qtyVal = parseInt($this.parent().find('.QuantitySelector__CurrentQuantity').val());
  var $isLimit = $('#jsc-is-limit').length;

  if ($qtyVal >= lmt_no && $isLimit == 0) {
    $this.prop('disabled', true);
    if ($('#limitError').length == 0) {
      $('.jsc-QuantitySelector').after('<p id="limitError" style="clear: both; color: red; font-size: 12px;">Only '+lmt_no+' product(s) per item</p>');
    }
  }

  if (lmt_no == 1) {
    setTimeout(function(){
      $this.parent().find('.QuantitySelector__CurrentQuantity').val(1);
    },300);
  }

  // $('.product-price').after('<p id="limitError" style="clear: both; color: red; font-size: 12px;">Only '+$oriLimit+' product(s) per item</p>');
}

disableAtcLimitQty = () =>{
  var $selectedElm = $('.jsc-selected-variant');
  if ($selectedElm.length > 0) {
    var $hiddenLimit = $('.jsc-hidden-limit');
    var $selectedId = $selectedElm.find(':selected').val() ? $selectedElm.find(':selected').val() : $selectedElm.val();
    var $isInCart = false;

    $hiddenLimit.each(function(){
      var $this = $(this);
      var $limit = $this.attr('data-limit');
      var $this_vid = $this.val();
      if ($selectedId == $this_vid) {
        $('.jsc-ProductForm__AddToCart').prop('disabled', true);
        $('.jsc-ProductForm__BuyButtons').append('<div class="jsc-limit-atc"></div>');
        if ($('#limitError').length == 0) {
          $('.jsc-QuantitySelector').after('<p id="limitError" style="clear: both; color: red; font-size: 12px;">Only '+$limit+' product(s) per item</p>');
        }
        $isInCart = true;
      }
    });

    if (!$isInCart) {
      // $('.jsc-ProductForm__AddToCart').prop('disabled', false);
      $('.jsc-limit-atc').remove();
      $('#limitError').remove();
      $('.jsc-pdp-plus').prop('disabled', false);
      $('.jsc-QuantitySelector').find('.QuantitySelector__CurrentQuantity').val(1);
    }

  }
}

resetCartNote = () =>{
  var $isResetNote = $('#jsc-reset-cart-note');

  if ($isResetNote.length > 0) {
    CartJS.setNote("");
  }
}

initBirthdayPicker = () =>{
  if ($('#jsc-birthday-text').length > 0) {
    $( "#jsc-birthday-text" ).datepicker({
      changeMonth: true,
      changeYear: true,
      maxDate: 1,
      yearRange: "c-100:c+10",
      dateFormat: "dd/mm/yy"
    });
  }
}
